import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://f13dpf-q0.myshopify.com/cart/47706120126618:1?channel=buy_button';
export function HeroSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-12 md:py-20 px-4" data-id="element-114">
      <div className="max-w-6xl mx-auto" data-id="element-115">
        <div className="text-center mb-8" data-id="element-116">
          <h1 className="text-4xl md:text-6xl font-black text-gray-900 mb-4 leading-tight" data-id="element-117"></h1>

          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-8 leading-snug max-w-5xl mx-auto" data-id="element-118">
            Creá una fuente de{' '}
            <span className="text-green-600" data-id="element-119">ingresos por internet</span> con{' '}
            <span className="text-green-600" data-id="element-120">Shopify</span>,{' '}
            <span className="text-green-600" data-id="element-121">IA</span> y una estructura clara
            para acercarte a una vida con más{' '}
            <span className="text-green-600" data-id="element-122">tiempo</span> y{' '}
            <span className="text-green-600" data-id="element-123">libertad</span>.
          </h2>

          <div className="flex justify-center mb-8" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/jfmattN8t4aZUaKr6WtVMA/1.png" alt="Dominando Shopify - Curso Completo" className="w-full max-w-2xl rounded-lg shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToCompra} data-id="element-125" />
          </div>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-4xl mx-auto" data-id="element-126">
            Un sistema simple para emprender online, vender con Shopify y usar
            IA para avanzar más rápido.
          </p>

          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-8 max-w-3xl mx-auto" data-id="element-127">
            <p className="text-lg md:text-xl text-gray-700 font-medium" data-id="element-128">
              Vas a salir con un plan claro para lanzar tu tienda, crear
              contenido, usar IA y empezar a generar tus primeras ventas.
            </p>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-129">
            Para emprendedores, principiantes y dueños de marca que quieren
            vender online con una estructura simple y sin perder tiempo.
          </p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 mb-8" data-id="element-130">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-131">
            ¿Qué incluye?
          </h3>
          <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto mb-8" data-id="element-132">
            {['Acceso al programa completo', '4 mentorías grupales en vivo', 'Plantillas', 'Prompts', 'Recursos para implementar'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-133">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-134" />
                <span className="text-lg text-gray-700" data-id="element-135">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-136">
          <CTAButton text="QUIERO EMPEZAR AHORA" onClick={scrollToCompra} size="large" className="w-full md:w-auto text-2xl animate-pulse-green" data-id="element-137" />
        </div>
      </div>
    </section>;
}